import { Injectable } from '@angular/core';
import {CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Principal} from "../../../common/services/principal";

@Injectable()
export class EnrollAuthGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private principal: Principal) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.principal.isLoggedIn()) {
      this.router.navigate(['/enroll/login'], {queryParams: {returnUrl: state.url}});
    }
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/services/enroll-auth.guard.ts